import { Navigate } from 'react-router-dom';
import { useFeatureFlag } from 'redux/utils/feature-flags/feature-flag-hook';

interface FeatureFlagRouteGuardProps {
  featureFlag: string;
  redirectTo?: string;
  children: React.ReactNode;
}

/**
 * FeatureFlagRouteGuard component that conditionally renders children based on a feature flag.
 * If the feature flag is disabled, redirects to the specified route (defaults to '/').
 *
 * @param featureFlag - The name of the feature flag to check
 * @param redirectTo - The path to redirect to if the feature flag is disabled (defaults to '/')
 * @param children - The content to render if the feature flag is enabled
 */
export const FeatureFlagRouteGuard: React.FC<FeatureFlagRouteGuardProps> = ({
  featureFlag,
  redirectTo = '/',
  children,
}) => {
  const isEnabled = useFeatureFlag(featureFlag);

  if (!isEnabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
